module.exports = __webpack_public_path__ + "static/media/Poppins-Regular-400.29cc97af.ttf";